const ACCOUNT_VERIFICATION_MESSAGES = {
  INVALID_TOKEN: 'Token is invalid',
  VERIFICATION_SUCCESS: 'Account successfully verified',
  VERIFICATION_FAILURE: 'Account verification Failed! Please try again'
};
export default ACCOUNT_VERIFICATION_MESSAGES;